import {
  InvoiceArrival,
  InvoiceArrivalStatus,
} from "@towersystems/roam-common/lib/generated-types";
import { useNavigation } from "@react-navigation/native";
import { Pressable } from "react-native";
import { Badge, Stack, Text } from "@towersystems/roam-common-native";
import { Colors, Spacings, View } from "react-native-ui-lib";
import {
  formatDateToCalendar,
  moneyToFormattedString,
} from "@towersystems/roam-common/lib/shared-utils";
import { AntDesign } from "@expo/vector-icons";
import { useTranslation } from "../../../../../../utilities/i18n";

export interface InvoiceArrivalResourceListItemProps {
  item: InvoiceArrival;
}
export const InvoiceArrivalResourceListItem = ({
  item,
}: InvoiceArrivalResourceListItemProps) => {
  const { t } = useTranslation("invoice_arrival");
  const navigation = useNavigation<any["navigation"]>();

  return (
    <Pressable
      onPress={() => {
        if (item.status === InvoiceArrivalStatus.PENDING) {
          navigation.navigate("EditInvoiceArrivalRootScreen", {
            invoiceArrivalId: item.id,
          });
        } else {
          navigation.navigate("ViewInvoiceArrivalRootScreen", {
            invoiceArrivalId: item.id,
          });
        }
      }}
    >
      <View flex row style={{ justifyContent: "space-between" }}>
        <View>
          <View centerV flex row>
            <Text variant="heading" fontWeight="medium">
              {t("formatted_invoice_number", {
                invoice_number: item.invoiceNumber,
              })}
            </Text>
            <Badge
              style={{ marginLeft: Spacings.s4 }}
              invoiceArrivalStatus={item.status}
            ></Badge>
          </View>
          {item.dueDate ? (
            <Text color="subdued">{formatDateToCalendar(item.dueDate)}</Text>
          ) : undefined}
          <Text color="subdued" style={{ display: "flex" }}>
            <Text style={{ minWidth: 50, display: "flex" }}>From:</Text>
            <Text style={{ display: "flex" }} fontWeight="bold">
              {item.supplier?.name ?? t("common:unknown_supplier")}
            </Text>
          </Text>
          <Text color="subdued" style={{ display: "flex" }}>
            <Text style={{ minWidth: 50, display: "flex" }}>To:</Text>
            <Text style={{ display: "flex" }} fontWeight="bold">
              {`${item.location?.name ?? t("common:unknown_location")}`}
            </Text>
          </Text>
        </View>
        <View style={{ alignContent: "center", justifyContent: "center" }}>
          <Stack spacing={Spacings.s1}>
            <View style={{ alignItems: "flex-end" }}>
              <Text variant="heading1" fontWeight="bold">
                {moneyToFormattedString(item.totalCost)}
              </Text>
              <Text textAlign="right">{t("total_price")}</Text>
              <Text color="subdued" textAlign="right">
                {t("formatted_quantity", {
                  quantity: item.totalQuantity ?? 0,
                })}
              </Text>
            </View>
            <View style={{ alignContent: "center", justifyContent: "center" }}>
              <Text fontWeight="bold" variant="heading1">
                <AntDesign
                  style={{ marginLeft: Spacings.s4, color: Colors.Text }}
                  name="right"
                  size={24}
                />
              </Text>
            </View>
          </Stack>
        </View>
      </View>
    </Pressable>
  );
};
